module.exports = __webpack_public_path__ + "img/shutdown_1_1.bcc830e5.png";